module.exports = __webpack_public_path__ + "img/4_63.bd31fa3c.png";